/**
 * Converts URLs in text to clickable links
 */
export function linkify(text: string): string {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-primary hover:text-primary/80 hover:underline break-all font-medium">${url}</a>`;
  });
}

/**
 * Converts URLs and preserves line breaks
 * Completely removes all empty lines for tighter spacing
 */
export function linkifyWithBreaks(text: string): string {
  // Split by lines, filter out empty lines, then join
  const lines = text.split('\n').filter(line => line.trim().length > 0);
  const withLinks = linkify(lines.join('\n'));
  return withLinks.replace(/\n/g, '<br />');
}
